import React from "react";

export default function Unauthorized () {
    return (<div className="alert-danger text-center">Access denied</div>);
}